/**
 * Extract a human-readable error message from an axios / fetch error.
 *
 * Axios attaches the server's response body at `error.response.data` — for our
 * FastAPI backend that's typically `{ detail: "..." }`. Fall back to the
 * Error message, then a generic string.
 */
export function apiError(e: unknown, fallback = 'Something went wrong'): string {
  if (e && typeof e === 'object') {
    const obj = e as { response?: { data?: { detail?: unknown } }; message?: unknown }
    const detail = obj.response?.data?.detail
    if (typeof detail === 'string' && detail) return detail
    if (Array.isArray(detail)) {
      // FastAPI 422 returns an array of validation errors
      const first = detail[0] as { msg?: unknown } | undefined
      if (first && typeof first.msg === 'string') return first.msg
    }
    if (typeof obj.message === 'string' && obj.message) return obj.message
  }
  return fallback
}
